// Shared helpers for the INBOUND admin pages.
// - authHeaders(): read the JWT stored by the auth context.
// - api(path, opts): thin fetch wrapper that surfaces backend errors.
export const AUTH_KEY = "geovinum.auth.v1";

export function authHeaders() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    const t = raw ? JSON.parse(raw)?.token : null;
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
}

export const api = (path, opts = {}) =>
  fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    ...opts,
    headers: { "Content-Type": "application/json", ...authHeaders(), ...opts.headers },
  }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.detail || `HTTP ${r.status}`);
    return data;
  });

export const CATEGORIES = [
  { value: "producer", label: "Producer" },
  { value: "appellation", label: "Appellation" },
  { value: "cepage", label: "Cépage" },
  { value: "article", label: "Article de blog" },
];
